import { convertIdToKey } from "../../utils";

export const fetchMovieContent = async ({ apiUrl, token, contentId }) => {
    try {
        const movieRes = await fetch(`${apiUrl}/movies`, { headers: { Authorization: `Bearer ${token}` } });
        const movieData = convertIdToKey((await movieRes.json()).movies);
        const selectedMovie = movieData.filter((each)=> each.key === contentId)

        return selectedMovie[0]
        
    } catch (error) {
        console.error("Failed to fetch movie content:", error);
        throw error;
    }
};

// For episode Content
export const fetchEpisodeContent = async ({ apiUrl, token, seriesId, season, episode }) => {
  const res = await fetch(`${apiUrl}/series`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const seriesList = convertIdToKey((await res.json()).series); 
  const episodes = seriesList.filter((each) => each.key === seriesId)[0].episodes;
  const selectedEpisode = episodes.filter((each) => each.season === Number(season) && each.number === Number(episode));
  
  return selectedEpisode[0]
};

// For Series Content
export const fetchSeriesContent = async ({ apiUrl, token, seriesId }) => {
  const res = await fetch(`${apiUrl}/series`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const seriesList = convertIdToKey((await res.json()).series); 
  const series = seriesList.filter((each) => each.key === seriesId)[0]

  return series
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// For Song Content
export const fetchSongContent = async ({apiUrl, token, contentId}) => {
    try {
        const songRes = await fetch(`${apiUrl}/songs`, { headers: { Authorization: `Bearer ${token}` } });
        const movieData = convertIdToKey((await songRes.json()).songs);
        const selectedSong = movieData.filter((each)=> each.key === contentId)

        return selectedSong[0]
        
    } catch (error) {
        console.error("Failed to fetch songs content:", error);
        throw error;
    }
}